import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import UsbIcon from '@mui/icons-material/Usb';
import { IconButton, Typography } from '@mui/material';
import { Stack } from '@mui/system';

type TitleProps = {
  onConnectUsb?: () => Promise<void>;
  isConnectedUsb?: boolean;
};

const Title: FC<TitleProps> = ({ onConnectUsb, isConnectedUsb }) => {
  const { t } = useTranslation(['checkout', 'common']);

  return (
    <Stack
      direction='row'
      alignItems='center'
      justifyContent='space-between'
      spacing={1}
    >
      <Typography variant='body1'>{t('checkout:cart')}</Typography>

      <Stack direction='row' spacing={1}>
        <IconButton onClick={onConnectUsb}>
          <UsbIcon
            sx={{
              color: isConnectedUsb ? 'success.main' : 'error',
            }}
          />
        </IconButton>
      </Stack>
    </Stack>
  );
};

export default Title;
